export default __webpack_public_path__ + "48623ee.png";